import React, { Component } from 'react';
import { render } from 'react-dom';

import { getFunName } from '../helpers';


class StorePicker extends Component {
	// constructor() {
	// 	super();
	// 	this.goToStore = this.goToStore.bind(this);
	// }
	
	goToStore(event) {
		event.preventDefault();
		const storeID = this.storeInput.value;
		this.context.router.transitionTo(`/store/${storeID}`)
	}

	render() {
		// Comment
		return (
			<form className="store-selector" onSubmit={this.goToStore.bind(this)}>
				{ /* Comment */ } 
				<h2>Please enter a store</h2>
				<input type="text" required placeholder="Store Name" defaultValue={getFunName()} ref={(input) => {this.storeInput = input}}/>
				<button type="submit">Visit store</button>
			</form>
		)
	}
}

StorePicker.contextTypes = {
	router: React.PropTypes.object
}


export default StorePicker;


/** WEBPACK FOOTER **
 ** ./src/components/StorePicker.js
 **/